import { useQuery } from 'src/shared/hooks/useQuery';

import type { TCompanyUser } from '../types';

import { useActiveCompany } from './useActiveCompany';

export const useActiveCompanyUser = () => {
  const { activeCompany } = useActiveCompany();
  const { data, ...rest } = useQuery<TCompanyUser>({
    enabled: Boolean(activeCompany),
    queryKey: [
      'organization',
      'companies',
      activeCompany?.id,
      'users',
      'current',
    ],
    url: `organization/companies/${activeCompany?.id}/users/current/`,
  });
  return { activeCompanyUser: data, ...rest };
};
